import { ReactNode } from 'react';
import {
  Button as MuiButton,
  ButtonProps,
  CircularProgress,
  Tooltip,
  TooltipProps,
  withStyles
} from '@material-ui/core';

const Button = withStyles({
  root: {
    minWidth: 'max-content',
    borderRadius: 8,
    '&.Mui-disabled': {
      pointerEvents: 'auto'
    },
    '& .MuiButton-startIcon': {
      marginLeft: 0,
      marginRight: 6
    },
    '& .MuiButton-endIcon': {
      marginLeft: 6,
      marginRight: 0
    }
  }
})(MuiButton);

export interface SButtonProps extends ButtonProps {
  children: ReactNode;
  loading?: boolean;
  className?: string;
  tooltipProps?: Partial<TooltipProps>;
  tooltipTitle?: string;
  tooltipPlacment?: TooltipProps['placement'];
}

const SButton = ({
  loading,
  onClick,
  disabled,
  children,
  className,
  color = 'primary',
  variant = 'contained',
  tooltipTitle = '',
  tooltipPlacment = 'top',
  fullWidth,
  startIcon,
  ...rest
}: SButtonProps) => {
  const disabledConfiguration = {
    disabled: disabled || loading,
    component: disabled ? 'div' : undefined,
    onClick: disabled ? undefined : onClick
  };

  return (
    <Tooltip
      arrow
      title={tooltipTitle}
      placement={tooltipPlacment}
      {...rest.tooltipProps}>
      <Button
        startIcon={
          loading ? <CircularProgress color="inherit" size={20} /> : startIcon
        }
        endIcon={rest.endIcon}
        color={color}
        variant={variant}
        className={className}
        fullWidth={fullWidth}
        {...rest}
        {...disabledConfiguration}>
        {children}
      </Button>
    </Tooltip>
  );
};
export default SButton;
